<div class="login-layout">

    <header>
      <img class="logo-main" src="favicon-without-background.ico" alt="Unifield Logo" />
      <h1>UNIFIELD</h1>
    </header>

  <main>
    <div class="container">
      <div class="login-left">
        <div class="title">
          <h1>Ici la donnée est un moteur<br> de <span class="accent">performance et sécurité</span> <br>pour vos chantiers.</h1>
        </div>

      </div>

      <router-outlet></router-outlet>
    </div>
  </main>
    <a mat-button href="" target="_blank" class="cgu">Conditions générales</a>
</div>